// src/components/Admin/tabs/UsersTab.jsx
import React, { useMemo } from 'react';
import { money, totalNights, REVENUE_STATUSES } from '../adminUtils';

// Estatus que cuentan como estancia real (ya sucedió o está en curso) para
// el conteo de "días con nosotros" - una reserva "pending"/"confirmed" que
// aún no ocurre no cuenta como día ya hospedado.
const STAYED_STATUSES = ['checked-in', 'checked-out', 'completed'];

const UsersTab = ({ users, bookings = [] }) => {
  const userStats = useMemo(() => {
    const stats = {};
    bookings.forEach((b) => {
      const userId = b.user?._id;
      if (!userId) return;
      if (!stats[userId]) stats[userId] = { daysWithUs: 0, totalPaid: 0 };

      if (STAYED_STATUSES.includes(b.status)) {
        stats[userId].daysWithUs += totalNights(b.checkInDate, b.checkOutDate);
      }
      // Aproximado: suma de reservas confirmadas o más avanzadas.
      // El registro exacto de pago vive en el modelo Order (paymentStatus),
      // no en Booking, así que esto es "dinero comprometido/cobrado
      // probablemente", no un estado de pago verificado.
      if (REVENUE_STATUSES.includes(b.status)) {
        stats[userId].totalPaid += b.totalPrice || 0;
      }
    });
    return stats;
  }, [bookings]);

  return (
    <div className="bg-white rounded-2xl border border-[#3A2A20]/10 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-[#3A2A20]/10 text-sm">
          <thead className="bg-[#EFE6DD]/60">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Nombre</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Email</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Dirección</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Días con nosotros</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Total pagado</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-[#3A2A20]/60">Admin</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#3A2A20]/10">
            {users.map((u) => {
              const addr = u.shippingAddress || {};
              const stats = userStats[u._id] || { daysWithUs: 0, totalPaid: 0 };
              return (
                <tr key={u._id}>
                  <td className="px-4 py-3 font-medium text-[#3A2A20]">{u.fullname}</td>
                  <td className="px-4 py-3 text-[#3A2A20]/70">{u.email}</td>
                  <td className="px-4 py-3 text-[#3A2A20]/70">
                    {u.hasShippingAddress && addr.direccion ? (
                      <>
                        {addr.direccion}, {addr.colonia}
                        <span className="block text-xs text-[#3A2A20]/40">{addr.zipcode}</span>
                      </>
                    ) : (
                      <span className="text-[#3A2A20]/30">Sin registrar</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-[#3A2A20]/70">{stats.daysWithUs}</td>
                  <td className="px-4 py-3 font-medium text-[#3A6B4C]">{money(stats.totalPaid)}</td>
                  <td className="px-4 py-3 text-[#3A2A20]/70">{u.isAdmin ? 'Sí' : 'No'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTab;